import { Component } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialogRef } from '@angular/material/dialog';
import { ColorFormat } from '@app/components/color-picker/interfaces';

interface ColunaQuadro {
  noColuna: string;
  noCor: string;
}

export interface DialogTarefaQuadroResultado {
  noQuadro: string;
  noCor: string;
  colunas: ColunaQuadro[];
}

@Component({
  selector: 'app-dialog-tarefa-quadro',
  templateUrl: './dialog-tarefa-quadro.component.html',
  styleUrls: ['./dialog-tarefa-quadro.component.css']
})
export class DialogTarefaQuadroComponent {
  public readonly atrasoArraste = { touch: 400, mouse: 0 };
  public noQuadro = '';
  public noCor = '#005485';
  public formatoCor: ColorFormat = 'hex';
  public colunas: ColunaQuadro[] = [
    { noColuna: 'A fazer', noCor: '#969696' },
    { noColuna: 'Em andamento', noCor: '#969696' },
    { noColuna: 'Concluído', noCor: '#969696' }
  ];

  public constructor(private readonly dialogRef: MatDialogRef<DialogTarefaQuadroComponent>) { }

  public get podeSalvar(): boolean {
    return !!this.noQuadro.trim() && this.colunas.every(coluna => !!coluna.noColuna.trim());
  }

  public adicionarColuna(): void {
    this.colunas.push({ noColuna: '', noCor: '#969696' });
  }

  public removerColuna(indice: number): void {
    if (this.colunas.length > 1) this.colunas.splice(indice, 1);
  }

  public reordenarColunas(evento: CdkDragDrop<ColunaQuadro[]>): void {
    if (evento.previousIndex !== evento.currentIndex) moveItemInArray(this.colunas, evento.previousIndex, evento.currentIndex);
  }

  public salvar(): void {
    const noQuadro = this.noQuadro.trim();
    const colunas = this.colunas.map(coluna => ({ ...coluna, noColuna: coluna.noColuna.trim() }));
    if (!noQuadro || colunas.some(coluna => !coluna.noColuna)) return;
    this.dialogRef.close({ noQuadro, noCor: this.noCor, colunas });
  }

  public cancelar(): void {
    this.dialogRef.close();
  }
}
